export default {
  resetZoom: 'Obnoviť priblíženie',
  exitFullscreen: 'Zatvoriť celú obrazovku',
  fullscreen: 'Celá obrazovka',
  showPoints: 'Zobraziť body',
  showNotes: 'Zobraziť poznámky',
  showExpertView: 'Zobraziť pohľad odborníka',
  leaveNote: 'Pridať poznámku (Alt + kliknutie)',
  zoomMode: 'Režim priblíženia',
  overFlowMenu: 'Ďalšie funkcie',
  markersMode: 'Režim značiek',
};
